/* ============================================================
   Custom product card – swipe galerie (globálně, celý web)
   Mobil (< 768px): swipe karusel s tečkami
   Desktop (>= 768px): klasická karta, hover řeší čistě CSS

   PERF v2 – stejná funkčnost, méně práce při načtení:
   1) LAZY INIT: karusel se inicializuje až když se karta blíží
      viewportu (200px předem), místo všech ~250 najednou při
      načtení stránky. Než uživatel kartu vidí, je hotová.
      Swipe (scroll-snap) i desktop hover jedou čistě přes CSS,
      takže fungují i před inicializací — JS jen doplňuje tečky
      a drag myší.
   2) MutationObserver je debouncovaný a reaguje JEN na přidání
      uzlů, které skutečně obsahují [data-col-track]. Dřív spustil
      plný querySelectorAll celého dokumentu při KAŽDÉ mutaci —
      a při načítání stránky mutují DOM desítky app skriptů
      (LoyaltyLion, Clarity, Loox…) prakticky nepřetržitě.
   AJAX gridy (filtry, stránkování, quick view) fungují stejně
   jako dřív — nové tracky observer zachytí a zařadí do lazy fronty.
   ============================================================ */
(function(){
  var active=null, startX=0, startScroll=0, moved=false;

  var DESKTOP_MQ = '(min-width: 768px)';
  function isDesktop(){
    return window.matchMedia && window.matchMedia(DESKTOP_MQ).matches;
  }

  // Při přepnutí mobil -> desktop vrátit scroll tracků na začátek,
  // aby overflow:hidden neuřízl kartu uprostřed rozjetého slidu
  if(window.matchMedia){
    var mq = window.matchMedia(DESKTOP_MQ);
    var onChange = function(e){
      if(!e.matches) return;
      document.querySelectorAll('[data-col-track]').forEach(function(t){ t.scrollLeft = 0; });
    };
    if(mq.addEventListener) mq.addEventListener('change', onChange);
    else if(mq.addListener) mq.addListener(onChange);
  }

  document.addEventListener('mousemove', function(e){
    if(!active) return;
    var dx = e.pageX - startX;
    if(Math.abs(dx) > 3) moved = true;
    active.scrollLeft = startScroll - dx;
  });
  document.addEventListener('mouseup', function(){
    if(!active) return;
    var t = active; active = null;
    t.classList.remove('col-dragging');
    var w = t.clientWidth || 1;
    t.scrollTo({ left: Math.round(t.scrollLeft / w) * w, behavior:'smooth' });
  });

  function initTrack(track){
    if(track.dataset.colInit) return; track.dataset.colInit='1';
    var carousel = track.closest('[data-col-carousel]'); if(!carousel) return;
    var slides = track.querySelectorAll('.product-grid-item__image-wrapper');
    var dots = carousel.querySelectorAll('[data-col-dot]');

    // zabránit tažení odkazu + tooltipu s URL
    var link = track.closest('a[data-grid-link]');
    if(link){ link.setAttribute('draggable','false'); link.removeAttribute('title'); }
    track.querySelectorAll('img').forEach(function(im){ im.setAttribute('draggable','false'); });
    track.addEventListener('dragstart', function(e){ e.preventDefault(); });

    if(slides.length < 2) return;

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            var idx = Array.prototype.indexOf.call(slides, e.target);
            for(var i=0;i<dots.length;i++){ dots[i].classList.toggle('is-active', i===idx); }
          }
        });
      }, { root: track, threshold: 0.6 });
      for(var s=0;s<slides.length;s++){ io.observe(slides[s]); }
    }

    for(var d=0; d<dots.length; d++){ (function(i){
      dots[i].addEventListener('click', function(ev){
        ev.preventDefault(); ev.stopPropagation();
        if(isDesktop()) return; // na desktopu tečky nejsou aktivní
        track.scrollTo({ left: i * track.clientWidth, behavior:'smooth' });
      });
    })(d); }

    // drag myší (touch jede nativně přes scroll-snap) – jen na mobilu
    track.addEventListener('mousedown', function(e){
      if(e.button !== 0) return;
      if(isDesktop()) return; // desktop = hover, žádný drag
      if(window.matchMedia && window.matchMedia('(hover: none)').matches) return;
      active = track; moved = false; startX = e.pageX; startScroll = track.scrollLeft;
      track.classList.add('col-dragging');
      e.preventDefault();
    });
    track.addEventListener('click', function(e){
      if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  /* ---- LAZY INIT: karusel se inicializuje, až když se blíží viewportu ----
     rootMargin 200px = inicializace proběhne dřív, než karta vjede na
     obrazovku, takže uživatel rozdíl nepozná.

     DŮLEŽITÉ: sledujeme CELOU KARTU (.product-grid-item), ne track uvnitř.
     Karta má v CSS content-visibility:auto — její POTOMCI se tím pádem
     mimo obrazovku vůbec nerozkládají (nemají rozměry), takže observer
     na tracku uvnitř by se spoléhal na to, že prohlížeč kartu "odskrytuje"
     dřív, než náš observer sáhne po tracku. Karta samotná rozměry má vždy
     (drží ji contain-intrinsic-size), takže sledovat ji je spolehlivé
     a nezávislé na content-visibility.

     Bez IntersectionObserver (prehistorické prohlížeče) se inicializuje
     rovnou jako dřív. */
  function initWithin(el){
    if(el.matches && el.matches('[data-col-track]')) { initTrack(el); return; }
    el.querySelectorAll('[data-col-track]').forEach(initTrack);
  }

  var lazyIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){
            lazyIO.unobserve(en.target);
            initWithin(en.target);
          }
        });
      }, { rootMargin: '200px' })
    : null;

  function queueTrack(track){
    if(track.dataset.colInit) return;
    if(!lazyIO){ initTrack(track); return; }
    // sledujeme kartu; když track není v kartě (quick view apod.), sledujeme track
    var target = track.closest('.product-grid-item') || track;
    if(target.dataset.colQueued) return;   // karta s víc tracky se hlídá jen jednou
    target.dataset.colQueued = '1';
    lazyIO.observe(target);
  }

  function initAll(root){
    (root||document).querySelectorAll('[data-col-carousel] [data-col-track]').forEach(queueTrack);
  }

  /* ---- Pojistka: dotyk/klik na track ho inicializuje okamžitě ----
     Kdyby observer z jakéhokoli důvodu ještě nestihl doběhnout, uživatel
     nepozná rozdíl — swipe jede nativně přes CSS, tohle jen zajistí,
     že tečky a drag myší jsou aktivní od první interakce. */
  document.addEventListener('pointerdown', function(e){
    var track = e.target.closest && e.target.closest('[data-col-track]');
    if(track && !track.dataset.colInit) initTrack(track);
  }, true);

  if(document.readyState !== 'loading'){ initAll(); }
  else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }

  /* ---- Sledování AJAX gridů (filtry, stránkování, quick view…) ----
     Debouncované a filtrované: plný sken dokumentu proběhne jen tehdy,
     když mutace skutečně přidala uzel obsahující [data-col-track].
     Mutace od app skriptů (chat, reviews, analytics…) se ignorují zdarma. */
  if('MutationObserver' in window){
    var pending = false;
    var scheduleInit = function(){
      if(pending) return;
      pending = true;
      var run = function(){ pending = false; initAll(document); };
      if('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 500 });
      else setTimeout(run, 150);
    };
    new MutationObserver(function(records){
      for(var i=0;i<records.length;i++){
        var added = records[i].addedNodes;
        for(var j=0;j<added.length;j++){
          var n = added[j];
          if(n.nodeType !== 1) continue;
          if((n.matches && n.matches('[data-col-track], [data-col-carousel]')) ||
             (n.querySelector && n.querySelector('[data-col-track]'))){
            scheduleInit();
            return;
          }
        }
      }
    }).observe(document.body || document.documentElement, { childList:true, subtree:true });
  }
})();